<template>
  <base-section id="info-alt" space="0">
    <!-- <v-container class="fill-height px-4 py-0">
      <v-slide-x-reverse-transition appear>
        <v-row>
          <v-responsive height="50%" max-width="1200" width="100%">
            <base-body>
              <v-row>
                <p
                  color="rgb(34, 34, 34)"
                  :class="[
                    $vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline',
                  ]"
                  class="pb-10 mt-16 ml-6 font-weight-bold"
                >
                  Contact Us
                </p>
                <v-spacer></v-spacer>
              </v-row>
            </base-body>
          </v-responsive>
        </v-row>
      </v-slide-x-reverse-transition>
    </v-container> -->

    <v-container class="mt-n16 mb-12">
      <v-row justify="space-between">
        <v-col cols="12" md="5">
          <base-business-info title="KEEP IN TOUCH WITH US">
            Your information is important to us.
          </base-business-info>
        </v-col>

        <v-col cols="12" md="6">
          <base-contact-form title="MAIL US YOUR MESSAGE" />
        </v-col>
      </v-row>
    </v-container>
    <!-- <SocialChat icon class="pb-16 whatsapp-chat" :attendants="attendants">
      <p slot="header">
        Click one of our representatives below to chat on WhatsApp.
      </p>

      <v-icon large colour="white" slot="button">fab fa-whatsapp</v-icon>
      <small slot="footer">Opening hours: 8am to 6pm</small>
    </SocialChat> -->
  </base-section>
</template>

<script>
import { SocialChat } from "vue-social-chat";
//import Feedback from "../../components/Feedback";
export default {
  name: "SectionKeepInTouch",
  metaInfo: {
    title: "Contact ",
    titleTemplate: "Strapp - Contact 📞",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },
  data: () => ({
    attendants: [
      {
        app: "whatsapp",
        label: "Technical support",
        name: "Darren De Abreu",
        number: "+27 79 506 1826",
        avatar: {
          src: require("@/assets/daz.png"),
          alt: "Darren De Abreu avatar",
        },
      },
      // ...
    ],
  }),
  components: {
    SocialChat,
    //Feedback: () => import("../../components/Feedback")
  },
};
</script>

<style>
#info-alt {
  margin-bottom: -150px;
}

.whatsapp-chat {
  --whatsapp: #46c056;
  --vsc-bg-header: var(--whatsapp);
  --vsc-bg-button: var(--whatsapp);
  --vsc-outline-color: var(--whatsapp);
}
</style>
